import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const languages = [
  { code: 'es', name: 'Español' },
  { code: 'ca', name: 'Català' },
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
];

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const normalizedLanguage = (i18n.language || 'es').split('-')[0];

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('i18nextLng', langCode);
  };

  const currentLanguage = languages.find(lang => lang.code === normalizedLanguage) || languages[0];

  return (
    <Select value={normalizedLanguage} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-auto min-w-[82px] bg-white border-gray-200 px-2">
        <SelectValue>
          <span className="text-sm font-semibold uppercase tracking-wide">{currentLanguage.code}</span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-white min-w-[170px]">
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <div className="flex items-center gap-2">
              <span className="text-xs font-semibold text-gray-500 uppercase w-6">{lang.code}</span>
              <span className="text-sm">{lang.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
